import React, { memo, useState } from 'react'

import Text from 'common-components/Text'
import InfoIcon from 'assets/svgr-icons/Info.svg'

import { TOP } from 'components/Tooltip/consts'
import { IIconProps, IProps, ITextProps } from './types'
import * as Styled from './styled'
import Icon from 'common-components/Icon'
import AdvancedTooltip from 'common-components/AdvancedTooltip'

const DEFAULT_TEXT_PROPS: ITextProps = {
  type: 'h2',
  fontWeight: 'bold',
  color: 'secondarySemiDark',
  lineHeight: '1.2'
}

const DEFAULT_ICON_PROPS: IIconProps = {
  size: 'medium',
  color: 'secondaryLight',
  icon: <InfoIcon />
}

const TextWithIconTooltip: React.FC<IProps> = props => {
  const {
    onClick,
    className,
    title,
    tooltipText,
    tooltipPosition = TOP,
    gap = 8,
    textProps = DEFAULT_TEXT_PROPS,
    iconProps = DEFAULT_ICON_PROPS,
    isIconVisible = true,
    showMobileTooltip = false
  } = props

  const _textProps = { ...DEFAULT_TEXT_PROPS, ...textProps }
  const _iconProps = { ...DEFAULT_ICON_PROPS, ...iconProps }

  const { icon, size, color, customSize } = _iconProps
  const shouldRenderIcon = isIconVisible && React.isValidElement(icon)

  const [wrapperRef, setWrapperRef] = useState<HTMLDivElement | null>(null)

  return (
    <Styled.TextWithIconTooltipWrapper
      className={className}
      $gap={gap}
      onClick={onClick}
      ref={setWrapperRef}
    >
      {title && <Text {..._textProps}>{title}</Text>}
      {shouldRenderIcon && (
        <Icon icon={icon} size={size} color={color} customSize={customSize} />
      )}
      {tooltipText && (
        <AdvancedTooltip
          btnRef={{ current: wrapperRef }}
          tooltipText={tooltipText}
          tooltipPosition={tooltipPosition}
          showMobileTooltip={showMobileTooltip}
        />
      )}
    </Styled.TextWithIconTooltipWrapper>
  )
}

export default memo(TextWithIconTooltip)
